module.exports = __webpack_public_path__ + "img/absorbente15.65ba80a1.jpg";